// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"configProvider_mulitpleDropdown__2FHOE","loaderWrapper":"configProvider_loaderWrapper__6PScG"};